import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { startGoogleFontAutoload } from '@shared-lib/shared-services/google-font-loader';

// Every Font dropdown offers the full Google Fonts catalogue; a family loads
// the moment the page uses it.
startGoogleFontAutoload();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
